"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFunnelConfiguration = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var FUNNEL_TEMPLATE = {
    chart: {
        type: "funnel",
        spacingRight: 100,
    },
    plotOptions: {
        funnel: {
            dataLabels: {
                enabled: true,
                crop: false,
                overflow: "none",
                padding: 2,
            },
        },
    },
    legend: {
        enabled: false,
    },
};
function getFunnelConfiguration() {
    return cloneDeep_1.default(FUNNEL_TEMPLATE);
}
exports.getFunnelConfiguration = getFunnelConfiguration;
//# sourceMappingURL=funnelConfiguration.js.map